import { render, staticRenderFns } from "./RegistrationCompetencies.vue?vue&type=template&id=1db1726e&scoped=true"
import script from "./RegistrationCompetencies.vue?vue&type=script&lang=js"
export * from "./RegistrationCompetencies.vue?vue&type=script&lang=js"
import style0 from "./RegistrationCompetencies.vue?vue&type=style&index=0&id=1db1726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1726e",
  null
  
)

export default component.exports